import { useState } from 'react';
import PropTypes from 'prop-types';

import CoevaluationInstructions from './CoevaluationInstructions/CoevaluationInstructions';
import CoevaluationsUsers from './CoevaluationsUsers/CoevaluationsUsers';

const CoevaluationUserContainer = props => {
  const [instructionsView, setInstructionsView] = useState(true);

  const changeViewHandler = () => {
    setInstructionsView(!instructionsView);
  };

  return (
    <>
      {instructionsView && (
        <CoevaluationInstructions
          changeViewHandler={changeViewHandler}
        />
      )}
      {!instructionsView && (
        <CoevaluationsUsers
          changeViewHandler={changeViewHandler}
          idCourse={props.idCourse}
          idLesson={props.idLesson}
          changeCoevaluationStatus={props.changeCoevaluationStatus}
        />
      )}
    </>
  );
};

CoevaluationUserContainer.propTypes = {
  // eslint-disable-next-line react/require-default-props
  idCourse: PropTypes.number,
  // eslint-disable-next-line react/require-default-props
  idLesson: PropTypes.number,
  // eslint-disable-next-line react/require-default-props
  changeCoevaluationStatus: PropTypes.func
};

export default CoevaluationUserContainer;
